/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Support_TabInputs */

const en_support_tab = /** @type {(inputs: Support_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support`)
};

const fr_support_tab = /** @type {(inputs: Support_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soutien`)
};

const de_support_tab = /** @type {(inputs: Support_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterstützung`)
};

const it_support_tab = /** @type {(inputs: Support_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supporto`)
};

const ru_support_tab = /** @type {(inputs: Support_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поддерживать`)
};

const es_support_tab = /** @type {(inputs: Support_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apoyo`)
};

const zh_cn2_support_tab = /** @type {(inputs: Support_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支持`)
};

const ja_support_tab = /** @type {(inputs: Support_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サポート`)
};

const hi_support_tab = /** @type {(inputs: Support_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सहायता`)
};

const pt_pt2_support_tab = /** @type {(inputs: Support_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apoiar`)
};

/**
* | output |
* | --- |
* | "Support" |
*
* @param {Support_TabInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const support_tab = /** @type {((inputs?: Support_TabInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_TabInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_support_tab(inputs)
	if (locale === "de") return de_support_tab(inputs)
	if (locale === "it") return it_support_tab(inputs)
	if (locale === "ru") return ru_support_tab(inputs)
	if (locale === "es") return es_support_tab(inputs)
	if (locale === "zh-CN") return zh_cn2_support_tab(inputs)
	if (locale === "ja") return ja_support_tab(inputs)
	if (locale === "hi") return hi_support_tab(inputs)
	if (locale === "pt-PT") return pt_pt2_support_tab(inputs)
	return en_support_tab(inputs)
});